var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataSourceList',{ref:"DataSource",attrs:{"columns":_vm.columns,"is-choose-model":true},on:{"handleCurrentChange":_vm.handleCurrentChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }